import { useChildSupportOrder } from "../../contexts/ChildSupportOrderContext";
import { Table, TableBody } from "../../design/table";
import ChildSupportOrderListItem from "./components/ChildSupportOrderListItem";

const ChildSupportOrdersListPage = () => {
  const { childSupportOrders } = useChildSupportOrder();

  return (
    <Table>
      <TableBody>
        {childSupportOrders.map((order) => (
          <ChildSupportOrderListItem
            key={order._id}
            childSupportOrder={order}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default ChildSupportOrdersListPage;
